module.exports = __webpack_public_path__ + "media/cloud-v1.70696dcd.mp4";